import { assert_array_typeof_boolean, assert_number_gte, assert_number_lte, assert_true, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__field_data } from '@shared/types/types';
import { UTILS__type } from '@shared/utils/UTILS__type';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { DECORATOR__class_serialization_tested } from './_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from './_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from './_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from './_base/DECORATOR__field_not_linked';
import { FIELD_PRIMITIVE__base } from './_base/FIELD_PRIMITIVE__base';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__bool extends FIELD_PRIMITIVE__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_BOOL;

  /*
   * FIELDS
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.BOOL;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  override get_value(): boolean {
    assert_type_boolean(this.value);

    return this.value;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  override set_value(value_new: boolean) {
    this.value = value_new;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  get_value_range(): boolean[] {
    this.assert_value_range(this.value_range);

    return this.value_range as boolean[];
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  set_value_range(value_new: unknown) {
    this.assert_value_range(value_new);

    this.value_range = value_new;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  get_values_allowed(): boolean[] {
    assert_array_typeof_boolean(this.values_allowed);

    return this.values_allowed;
  }

  /*
   * PROPERTIES
   */
  override get grid2d_dimension_values(): boolean[] {
    assert_true(this.meta.grid2d__is_dimension);

    return [false, true];
  }

  /*
   * METHODS
   */

  constructor() {
    super();

    this.value_range = [false, true];
    this.values_allowed = [false, true];
  }

  invert() {
    this.set_value(!this.get_value());
  }

  /*
   *
   */

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  store__can_deserialize_from_data(map: MAP__field_data) {
    if (!super.store__can_deserialize_from_data(map)) return false;

    let values_allowed = map.get_or_default('values_allowed', this.values_allowed);
    if (!UTILS__type.is_array_of__boolean(values_allowed)) return false;

    /*
     *
     */

    return true;
  }

  /*
   *
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_boolean(this.value);

    this.assert_value_range(this.value_range);
  }

  assert_value_range(value_range: unknown) {
    assert_array_typeof_boolean(value_range);

    assert_number_gte(value_range.length, 1);
    assert_number_lte(value_range.length, 2);
  }
}
